export default {
  createSuccess: "Structure created successfully!",
  updated: "Structure updated!",
  deviceNameEmpty: "Device name cannot be empty",
  deviceRenamed: "Device renamed",
  adminRenameConfirmTitle: "Change display name?",
  adminRenameConfirmMessage:
    'The display name "{{name}}" helps hosts recognize their tablets. Changing it without the host\'s consent may cause confusion. You can still proceed if needed.',
  credentialsRegenerated: "Credentials regenerated",
  createModal: {
    title: "Add New Structure",
    houseNameLabel: "Structure name *",
    houseNamePlaceholder: "e.g., Villa Sunset",
    addressRequired: "Enter the structure address.",
    commissionPercentLabel: "Host share of each booking (%)",
    nameRequired: "Enter a structure name.",
    commissionPercentRange: "Enter a valid percentage.",
    salesAgent: "Sales agent (contract)",
    salesAgentSearchPlaceholder: "Type an email to search…",
    salesAgentNoResults: "No sales agents match your search.",
    salesAgentListEmpty: "No sales agents available.",
    wizardStep2Lead:
      "Select a sales agent from the list, or skip to continue without one.",
    salesAgentCutPercentLabel: "Sales agent commission (%)",
    salesAgentCutRequired:
      "Enter the sales agent commission when an agent is selected.",
    wizardStep3Lead: "Enter the full address for this structure.",
    wizardNext: "Continue",
    wizardSkip: "Skip",
    create: "Create Structure",
  },
  adminCreate: {
    back: "Back to structures",
    backToHost: "Back to host",
  },
  list: {
    openHouse: "Open",
    hostIdMissing: "Host ID not found. Please log in as a host.",
    titleAdminNoHosts: "Structures",
    subtitleAdminNoHosts:
      "Create a host first, then you can add structures for them.",
    emptyHosts: "No hosts registered yet. Add hosts from the Hosts section.",
    titleByHost: "Structures by host",
    titleMy: "My Structures",
    subtitleByHost: "Pick a host, then view or add their structures",
    subtitleMy:
      "View structures assigned to your account and manage their tablets",
    hostLabel: "Host",
    selectHostAria: "Select host",
    addHouse: "Add Structure",
    emptyTitle: "No structures yet",
    emptyDescAdmin: "Add a structure for this host.",
    emptyDescHost:
      "Staff will create structures for your account.",
    addFirstHouse: "Add First Structure",
    loading: "Loading structures…",
    active: "Active",
    inactive: "Inactive",
    commissionRate: "{{percent}}% host share",
    hostOptionLabel: "{{name}} (host)",
  },
  detail: {
    createdOn: "Created {{date}}",
    overview: {
      devices: "Tablets",
      devicesHint: "Assigned to this structure",
      devicesOnline_one: "{{count}} online",
      devicesOnline_other: "{{count}} online",
      guestsNow: "Guests now",
      guestsNowHint: "Occupied tablets of {{count}}",
      upcoming: "Queued arrivals",
      upcomingHint: "Future stays on the tablets",
      hostShare: "Host share",
      hostShareHint: "On every booking made from this structure's tablets",
    },
    settings: {
      visibilityTitle: "Visibility",
    },
    notFoundMessage:
      "This structure may have been removed or you may not have access to it.",
    loading: "Loading structure…",
    back: "Back to Structures",
    backToHouses: "Back to houses",
    goToPartner: "Go to partner",
    partnerLabel: "Partner",
    tabs: {
      settings: "Settings",
      ariaLabel: "Structure setup sections",
      devices: "Devices",
      devicesHintAdmin:
        "Assign tablets to this structure, link payment readers, and manage device credentials.",
      presences: "Presences",
    },
    presences: {
      staysTitle: "Guest stays",
      segmentCurrent: "Now ({{count}})",
      segmentUpcoming: "Upcoming ({{count}})",
      segmentAria: "Guest stays view",
      currentHint:
        "Guests currently assigned to tablets in this structure, as reported by the host.",
      upcomingHint:
        "Guests scheduled to arrive on tablets in this structure, including stays imported from PDF.",
      historyHeading: "Historical occupancy",
      historyHint:
        "Occupancy is calculated as occupied device time divided by total device capacity in the selected period.",
      loadingHistory: "Loading period presences…",
      errorConnectionMessage:
        "Check your connection or permissions, then try again.",
      errorHistoryTitle: "Could not load period presences",
      emptyCurrentMessage:
        "No tablets in this structure currently have an active guest.",
      emptyUpcomingMessage:
        "No upcoming guest stays are scheduled for this structure.",
      emptyHistoryMessage: "No presences overlap the selected period.",
      colDevice: "Device",
      colNationality: "Nationality",
      colMarketing: "Marketing",
      colGuests: "Guests",
      colContacts: "Contacts",
      copyContactHint: "Click to copy",
      guestsWithCount: "{{name}} (x{{count}})",
      childrenBadgeHint: "Children are part of this stay",
      colArrival: "Arrival",
      colDeparture: "Departure",
      colNotes: "Notes",
      notesAria: "View guest notes",
      colActions: "Actions",
      editAction: "Edit presence",
      deleteAction: "Remove presence",
      editModalTitle: "Edit presence – {{deviceName}}",
      consentMarketing: "Direct marketing",
      consentProfiling: "Profiling",
      consentThirdParty: "Third-party marketing",
      consentGrantedHint: "The guest consented to:",
      consentDeniedHint: "The guest did not give any marketing consent.",
      valueUnknown: "—",
      genericGuestName: "Guest",
      dateFrom: "From",
      dateTo: "To",
      applyRange: "Apply",
      resetRange: "Last 3 months",
      metricOccupancy: "Occupancy",
      metricOccupancyHint: "Average tablet occupancy in the selected period",
      metricDevices: "Devices",
      metricPresences: "Presences",
      chartHeading: "Daily occupancy",
      chartAria: "Daily occupancy chart for the selected period",
      periodTableHeading: "Presences in period",
      periodTableHint: "Stays that overlap the selected period.",
      currentIndicatorHint: "This presence is currently active.",
      emptyPeriodMessage: "No presences overlap the selected period.",
    },
    presenceImport: {
      title: "Import presences from PDF",
      adminOnly: "Staff only",
      barHint:
        "Extract guest stays from a PDF (including scans), then review required fields.",
      open: "Import PDF",
      hint: "Upload any occupancy PDF — guest lists, PMS exports, or scans. Fill any blank required fields, then save.",
      fileLabel: "PDF only",
      dropHint: "Click to choose a PDF",
      extract: "Extract stays",
      save: "Save presences",
      cancel: "Discard",
      chooseAnother: "Choose another PDF",
      addRow: "Add stay",
      previewCount: "{{count}} stay(s) to review",
      colDevice: "Device",
      colGuest: "Guest name",
      colNationality: "Nationality",
      colArrival: "Arrival",
      colDeparture: "Departure",
      devicePlaceholder: "Select device",
      unmatchedHint: "From the PDF: {{room}}",
      removeRow: "Remove stay",
      pickFile: "Choose a PDF file first.",
      emptyPreview: "No stays to save. Extract again or discard.",
      toastExtracted: "Extracted {{count}} stay(s). Review before saving.",
      toastSaved: "Saved {{count}} presence(s).",
      undo: "Undo",
      discardConfirmTitle: "Discard your work?",
      discardConfirmMessage:
        "If you continue without saving, you will lose the extracted stay edits.",
      discardConfirmAction: "Discard and continue",
      discardConfirmCancel: "Keep editing",
      extractingHint: "Analyzing PDF…",
      fileSelectedHint: "PDF selected — click to choose a different file",
      unassignedBanner:
        "{{count}} stay(s) still need a tablet. Assign every stay before saving.",
      unassignedDeviceError: "Assign a tablet",
      unassignedDeviceTitle: "No tablet assigned",
      assignedDeviceTitle: "Tablet assigned",
      scheduleHint: "Default times: check-in ~15:00 · check-out ~10:00",
      invalidDateRange: "Departure before arrival",
    },
    visibilityLabel: "Active structure",
    visibilityHint:
      "Inactive structures are hidden from host workflows until reactivated.",
    visibilityToggleAria: "Activate or deactivate this structure",
    devicesTitle: "Devices ({{count}})",
    noDevices: "No devices in this structure",
    noDevicesHint:
      "Staff can create new devices from the Devices tab and then assign them here.",
    deviceNamePlaceholder: "Device name",
    renameDeviceTitle: "Rename device",
    kioskCode: "Device code",
    serialLabel: "S/N",
    currentGuest: "Current guest",
    guestDeparts: "departs {{date}}",
    statusRevoked: "Revoked",
    statusCreated: "Created",
    statusActive: "Active",
    regenerateConfirm:
      'Regenerate password for "{{name}}"? Existing tablet sessions will be invalidated and the current password will stop working.',
    credentialModalTitle: "Credentials regenerated",
    credentialModalDesc:
      "The password has been regenerated. Save these credentials now: the password is shown only once.",
    managePresences: "Manage guests",
    addPresences: "Add guests",
    noGuestPresence: "No guests recorded yet",
    queuedGuests: "{{count}} queued",
    queuedGuests_one: "1 queued",
    noCurrentGuestWithQueue: "No current guest · {{count}} queued",
    noCurrentGuestWithQueue_one: "No current guest · 1 queued",
    refreshCredentials: "Refresh credentials",
    refreshingCredentials: "Refreshing…",
    hostDevicesCaption:
      "Login codes and device details are managed by staff. Set a friendly tablet name here, drag to reorder, and record guests.",
    dragToReorder: "Drag to reorder",
    modalHouseName: "Structure name",
  },
  adminDetail: {
    houseName: "Structure name",
    placeholderHouseName: "e.g. Beach Villa",
    locationTitle: "Location",
    commissionSettings: "Host share settings",
    commissionPct: "Host share of each booking (%)",
    commissionPlaceholder: "e.g. 5",
    assignDevice: "Assign device",
    assignDeviceCta: "Assign a device",
    colDevice: "Display name",
    colSerial: "S/N",
    colGoogleAccount: "Google account",
    colFreekioskUnlock: "FK unlock",
    colReader: "Reader",
    colLastTelemetry: "Last telemetry",
    colLastInteraction: "Last interaction",
    colAppVersion: "App version",
    colInUse: "In use",
    colActions: "Actions",
    renameDeviceTitle: "Edit display name",
    displayNamePlaceholder: "Display name",
    displayNameEmpty: "Display name cannot be empty",
    editGoogleAccountTitle: "Edit Google account",
    editNotesTitle: "Notes",
    notesPlaceholder: "Add a note…",
    moreActionsTitle: "More actions",
    readerPair: "Link",
    readerUnpairTitle: "Unlink reader",
    readerUnpairConfirm:
      "Unlink this reader from the tablet? Pairing with SumUp is kept; payments stay disabled until you link again.",
    readerUnpaired: "Reader unlinked",
    unassignDeviceTitle: "Unassign device",
    menuRegenerateCredentials: "Regenerate credentials",
    menuRevokeDevice: "Revoke credentials",
    menuReactivateDevice: "Reactivate credentials",
    menuManagePresences: "Manage guests",
    menuNotes: "Notes",
    menuOtherInfo: "Other info",
    toastAssignSuccess: "Device assigned successfully!",
    toastUpdateSuccess: "Structure updated successfully!",
    toastReaderUpdated: "Reader updated",
    toastDeviceRevoked: "Device revoked",
    toastDeviceReactivated: "Device reactivated",
    toastDeviceShelved: "Device parked",
    toastDeviceUnshelved: "Device back in use",
    toastDeviceUnassigned: "Device unassigned",
    toastDeviceRenamed: "Device renamed",
    toastGoogleAccountUpdated: "Google account updated",
    toastNotesUpdated: "Notes updated",
    unassignConfirm: 'Unassign "{{name}}" from this structure?',
    assignModalTitle: "Assign device to structure",
    assignModalIntro: "Select a device to assign to {{houseName}}:",
    searchDevicesLabel: "Search devices",
    filterDevicesPlaceholder: "Name, code or serial…",
    searchDevicesPlaceholder: "Search by display name, code, or serial…",
    assignModalNoResultsSearch: 'No devices found matching "{{query}}".',
    assignModalNoResults: "No available devices to assign.",
    assign: "Assign",
    deviceListMeta: "{{code}} — S/N: {{serial}}",
    otherInfoTitle: "Other device info",
    fieldDisplayName: "Display name",
    fieldKioskCode: "Device code",
    fieldSerialNumber: "Serial number",
    fieldGoogleAccount: "Google account",
    fieldSoftwareId: "Software ID",
    fieldReaderId: "Reader ID",
    fieldBrand: "Brand",
    fieldDisplayInches: "Display inches",
    fieldResolution: "Resolution",
    fieldAndroidVersion: "Android version",
    fieldAppVersion: "App version",
    valueAppVersionUnknown: "Unknown",
    valueAppVersionLegacy: "<=0.4.0",
    valueFreekioskUnlockUnavailable: "—",
    fieldLastTelemetryReport: "Last telemetry received",
    sectionTelemetryData: "Telemetry data",
    sectionTelemetryDeviceStatus: "Device status (FreeKiosk)",
    sectionTelemetryGpsLocation: "Location (device GPS)",
    valueTelemetryNever: "Never",
    valueTelemetryEmpty: "No data yet",
    valueUnbound: "Unbound",
    valueNotPaired: "Not linked",
    telemetryBattery: "Battery",
    telemetryWifi: "WiFi signal",
    telemetryAudio: "Audio volume",
    telemetryStorage: "Storage used",
    telemetryMemory: "RAM used",
    telemetryUnavailable: "-",
    telemetryDataAge: "Data from {{age}}",
  },
  kioskPresence: {
    modalTitle: "Guests – {{kioskName}}",
    tabletFallback: "Tablet",
    toastAdded: "Guest registered",
    toastUpdated: "Guest updated",
    toastDeleted: "Guest removed",
    errorGuestNameRequired: "Guest first name is required",
    errorNationalityRequired: "Nationality is required",
    errorDatesRequired: "Arrival and departure dates are required",
    errorDepartureDateRequired: "Departure date is required",
    errorDepartureAfterArrival: "Departure must be after arrival",
    deleteConfirm: 'Remove guest "{{guestName}}"?',
    replaceCurrentTitle: "End current guest stay?",
    replaceCurrentMessage:
      "{{guestName}} is currently checked in on this tablet. To register a new guest, we'll end the current stay now and start the new one.",
    replaceCurrentConfirm: "End stay and register new guest",
    sectionCurrentGuest: "Current guest",
    sectionUpcoming: "New guest",
    emptyNoCurrentGuest: "No current guest",
    emptyNoUpcoming: "No guests registered",
    ctaAddPresence: "Add guest",
    labelGuestName: "Guest first name",
    labelGuestLastName: "Last name",
    labelGuestEmail: "Email",
    labelGuestPhone: "Phone",
    labelNationality: "Nationality",
    labelArrivalDate: "Arrival date",
    labelArrivalTime: "Arrival time",
    labelDepartureDate: "Departure date",
    labelDepartureTime: "Departure time",
    scheduleLaterArrival: "Guest arrives on a later date",
    scheduleLaterArrivalHint:
      "Leave unchecked to check in from now. Enable to queue a future stay on this tablet.",
    labelPeople: "People",
    labelChildrenCheckbox: "Children",
    labelNotes: "Notes",
    childrenBadge: "Children",
    placeholderGuestName: "e.g. Mario",
    placeholderGuestLastName: "e.g. Rossi",
    placeholderGuestEmail: "e.g. mario.rossi@email.com",
    placeholderGuestPhone: "e.g. +393331234567",
    placeholderNationality: "e.g. Italy",
    placeholderNotes: "Optional notes...",
    peopleCount_one: "{{count}} person",
    peopleCount_other: "{{count}} people",
    buttonAddPresence: "Register guest",
    buttonUpdatePresence: "Update guest",
    consentSectionTitle: "Consent form",
    consentSectionHint:
      "Email and phone are stored only if the guest accepts at least one option below.",
    consentMarketing:
      "I CONSENT to the processing of my personal data by Guestify Italia S.r.l. for marketing communications, newsletters and commercial offers.",
    consentProfiling:
      "I CONSENT to the processing of my personal data by Guestify Italia S.r.l. to analyze my preferences and receive personalized offers and services.",
    consentThirdParty:
      "I CONSENT to the transfer of my personal data by Guestify Italia S.r.l. to selected partners for marketing purposes.",
    consentRecordedBadge: "Consent recorded",
  },
} as const;
